import { render, staticRenderFns } from "./XHelpWarning.vue?vue&type=template&id=49507cae&scoped=true"
import script from "./XHelpWarning.vue?vue&type=script&lang=js"
export * from "./XHelpWarning.vue?vue&type=script&lang=js"
import style0 from "./XHelpWarning.vue?vue&type=style&index=0&id=49507cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49507cae",
  null
  
)

export default component.exports